import { render } from "./Section.vue?vue&type=template&id=0bdbd9b0&scoped=true"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"

import "./Section.vue?vue&type=style&index=0&id=0bdbd9b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdbd9b0"]])

export default __exports__